<template>
  <div
    class="ticket-form"
    :aria-busy="Object.keys(candidate).length === 0 ? 'true' : 'false'"
  >
    <h2>{{ 'ticketPanel' | translate }}</h2>
    <section
      v-if="ticketStep === 'intro'"
      class="content"
    >
      <form
        @submit.prevent="SET_TICKET_STEP({step: 'userData'})"
      >
        <p>
          clique no botão abaixo para utilizar o vale eleitoral do <strong>
            {{ candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
              'partido' : '' }} {{ candidate.party.name }}
          </strong>.
        </p>

        <button
          type="submit"
        >
          {{ 'submitTicket' | translate }}
        </button>
      </form>
    </section>

    <template
      v-if="ticketStep === 'userData'"
    >
      <userData
        :is-ticket="true"
      />
      <p class="form__disclaimer">
        Todos dados serão utilizados para que
        <strong>
          {{ candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
            'Partido' : '' }} {{ candidate.party.name }}
        </strong>
        possa enviar informativos.
      </p>
    </template>

    <addressData
      v-if="ticketStep === 'addressData'"
      :is-ticket="true"
    />
    <template v-if="ticketStep === 'finalMessage'">
      <p>
        Obrigado!
      </p>

      <p>
        O seu vale foi computado e quando a campanha começar, vamos
        contabilizar todos os vales registrados e dividir de forma
        proporcional entre todos os candidaturas do {{
          candidate.party.name.toLowerCase().indexOf('partido') === -1 ?
            'Partido' : '' }} {{ candidate.party.name }} ({{ candidate.address_city
        }}).
      </p>

      <p>
        Além deste vale, você também pode <a href="#doar">doar</a>
        qualquer quantia financeira de pessoa física para fortalecer ainda
        mais as candidaturas que te representam!
      </p>
    </template>
  </div>
</template>

<script>
import userData from './steps/userData.vue';
import finalMessage from './steps/finalMessage.vue';
import addressData from "./steps/addressData.vue";
import { mapMutations } from 'vuex';

export default {
	name: 'Ticket',
	components: {
		userData,
		addressData,
	},
	data(){
		return{
			loading: false,
      dataBusyMessage: '',
		}
	},
	computed: {
		ticketStep() {
			return this.$store.state.ticketStep;
		},
		candidate() {
			return this.getMergeCandidate.candidate;
		},
		getMergeCandidate() {
			return this.$store.getters.generateCandidateObject;
		},
  },

	methods: {
    toggleLoading(message = '') {
      this.loading = !this.loading;

      this.dataBusyMessage = this.dataBusyMessage !== message
        ? message
        : '';
    },
    ...mapMutations([
      'SET_TICKET_STEP',
    ])
  },
};
</script>

<style>
.home__donate h2 {
	color: #ffffff;
}

</style>



// WEBPACK FOOTER //
// _source/javascript/components/Ticket.vue